import { useRef } from "react";
import { EmptyActivityCard } from "views/components/Schedules/styles";
import useUpdateActivityPopup from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopup";
import UpdateActivityPopup from "views/components/Schedules/components/UpdateActivityPopup";
import AdminReservationForm from "./AdminReservationForm";

const ScheduleFreeActivity = ({
    activityColor,
    quantityCells = 4,
    openDialogNonBusinessDay,
    data, space, filterDate, 
    isNonBusinessDay
}) => {
    const $activity = useRef();
    const updateActivityPopup = useUpdateActivityPopup({
        $activity
    });
    function getClassName() {
        const classList = [
            "empty-activity",
            "clickeable",
            activityColor
        ];
        return classList.join(" ");
    }
    return (
        <td rowSpan={quantityCells}>
            <UpdateActivityPopup updateActivityPopup={updateActivityPopup}>
                <AdminReservationForm
                    data={data} space={space}
                    filterDate={filterDate}
                    updateActivityPopup={updateActivityPopup}/>
            </UpdateActivityPopup>
            <EmptyActivityCard
                ref={$activity}
                className={getClassName()}
                heightRatio={quantityCells}
                onClick={() => {
                    if (isNonBusinessDay)
                        openDialogNonBusinessDay();
                    else updateActivityPopup.popup.open();
                }} />
        </td>
    );
}

export default ScheduleFreeActivity;